import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  SimpleGrid,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiAward } from "react-icons/fi";

const awards = [
  {
    year: "بهمن ۱۴۰۳",
    title: "رتبه اول در حوزه تأمین مالی",
    source: "بازار سرمایه ایران",
  },
  {
    year: "اسفند ۱۴۰۳",
    title: "رتبه اول مشارکت در انتشار عرضه اولیه سهام",
    source: "سازمان بورس و اوراق بهادار",
  },
  {
    year: "خرداد ۱۴۰۴",
    title: "رتبه سوم مشاوره عرضه و تعهد خرید",
    source: "بازار سرمایه ایران",
  },
  {
    year: "آبان ۱۴۰۴",
    title: "غرفه برتر نمایشگاه Kish Invex",
    source: "نمایشگاه بین‌المللی کیش اینوکس",
  },
];

export const SectionAwards = () => {
  const headingColor = useColorModeValue("gray.900", "white");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const cardBg = useColorModeValue("white", "dark.300");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const yearBg = useColorModeValue("brand.50", "icon.bg");
  const yearColor = useColorModeValue("brand.600", "icon.svg");

  return (
    <Box>
      <Container maxW="container.xl">
        <VStack spacing={8} align="stretch">
          <VStack spacing={3} align="center" textAlign="center">
            <Heading
              as="h2"
              fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
              fontWeight="bold"
              color={headingColor}
            >
              افتخارات و رتبه‌بندی‌ها
            </Heading>
            <Text fontSize={{ base: "sm", md: "md" }} color={textColor}>
              دستاوردهای معتبر و قابل استناد
            </Text>
          </VStack>

          <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={4}>
            {awards.map((a) => (
              <Box
                key={a.title}
                bg={cardBg}
                borderRadius="xl"
                border="1px solid"
                borderColor={borderColor}
                p={4}
                _hover={{ shadow: "md", borderColor: "brand.200" }}
                transition="all 0.3s"
              >
                <VStack align="flex-start" spacing={2}>
                  <HStack>
                    <Icon
                      verticalAlign="middle"
                      as={FiAward as any}
                      color={yearColor}
                      boxSize={4}
                    />
                    <Box bg={yearBg} px={2} py={0.5} borderRadius="md">
                      <Text fontSize="xs" fontWeight="bold" color={yearColor}>
                        {a.year}
                      </Text>
                    </Box>
                  </HStack>
                  <Text fontWeight="bold" fontSize="sm" color={headingColor}>
                    {a.title}
                  </Text>
                  <Text fontSize="xs" color={textColor}>
                    {a.source}
                  </Text>
                </VStack>
              </Box>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};
